import React from 'react';
import { ComparisonDetailMembersDataType } from '../../types';
import { useTranslation } from 'react-i18next';
import './MatchStatSection.css';
import { useFormatters } from "../../utils/texts";
import { useAppContext } from '../../context/AppContext';
import { DateTime } from 'luxon';

type Props = {
    comparison: ComparisonDetailMembersDataType['comparison'];
    dateFrom: string | null;
    dateTo: string | null;
};

const MatchStatSection = ({ comparison, dateFrom, dateTo }: Props) => {
    const { t, i18n } = useTranslation(['analyses']);
    const { municipalityData } = useAppContext();
    const timeZone = municipalityData.casova_zona;
    const currentLocale = i18n.language;
    const formatter = useFormatters(currentLocale);

    const formatSafeDate = (dateStr: string | null): string | null => {
        if (!dateStr) return null;
        const dt = DateTime.fromISO(dateStr, { zone: timeZone });
        return dt.isValid 
            ? dt.setLocale(currentLocale).toLocaleString(DateTime.DATE_FULL) 
            : null;
    };

    const formattedDateFrom = formatSafeDate(dateFrom);
    const formattedDateTo = formatSafeDate(dateTo);

    return (
        <>
            <div className='comparison-match-container'>
                <p className='match-percentage'>{formatter.percent2From100(comparison?.match_stat ?? 0)}</p>
                <p className='match-text'>{t('comparison.MatchStatSection.votingAgreement')}</p>
                <p className='match-tooltip'>{t('comparison.MatchStatSection.votingAgreementTooltip')}</p>
            </div>
            <p id='mandate-date-text'>
                {dateFrom && dateTo ? (
                    <>
                        {t('comparison.MatchStatSection.mandateRange', { from: formattedDateFrom, to: formattedDateTo })}
                    </>
                ) : dateFrom ? (
                    <>
                        {t('comparison.MatchStatSection.mandateFrom', { from: formattedDateFrom })}
                    </>
                ) : dateTo ? (
                    <>
                        {t('comparison.MatchStatSection.mandateTo', { to: formattedDateTo })}
                    </>
                ) : (
                    <>{t('comparison.MatchStatSection.mandateEntireTerm')}</>
                )}
            </p>
        </>
    );
};

export default MatchStatSection;
